import * as React from 'react'

function SvgCallback(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.06 13c0 5.49 4.45 9.94 9.94 9.94.166 0 .365-.014.582-.038l-1.273-2.134a1.5 1.5 0 012.576-1.537l2.391 4.009a1.5 1.5 0 01-.971 2.235c-.726.156-2.26.465-3.304.465C5.854 25.94.06 20.147.06 13 .06 5.853 5.854.06 13 .06 20.146.06 25.94 5.853 25.94 13c0 3.234-.48 4.732-2.441 7a1.5 1.5 0 01-2.27-1.962c1.509-1.744 1.71-2.552 1.71-5.038 0-5.49-4.45-9.94-9.94-9.94-5.49 0-9.94 4.45-9.94 9.94z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgCallback
